import Vue from 'vue';

const initialState = {
  discounts: [],
}

const state = {...initialState};


export default {
  state,
  actions: {
  },
  mutations: {
    discounts(state, list) {
      Vue.set(state, 'discounts', [...list]);
      // state.discounts =  list || [];
    },
  },
  getters: {
    discounts: (state, getters, rootState, rootGetters) => {
      return state.discounts;
    },
  },

}
